import React from 'react';

export default function CGU({ onBack }) {
  return (
    <div style={{maxWidth:'720px',margin:'0 auto',padding:'36px 24px 60px'}}>
      <span style={{fontSize:'12px',color:'#888',cursor:'pointer',marginBottom:'24px',display:'inline-block'}} onClick={onBack}>← Retour</span>
      <h1 style={{fontSize:'24px',fontWeight:'700',marginBottom:'8px'}}>Conditions Générales d'Utilisation</h1>
      <p style={{fontSize:'12px',color:'#888',marginBottom:'32px'}}>recensement-enfantsnonproteges.fr — Dernière mise à jour : juillet 2026</p>

      {[
        {
          title: '1. Présentation du site',
          content: [
            'Le site recensement-enfantsnonproteges.fr est édité par Eve Simonet, en qualité d\'éditrice responsable.',
            'Ce site est porté par un collectif de mères protectrices fondé par Priscilla Majani, Maryline Perrinet et Sophie Abida. Il a pour vocation de recenser et de documenter les situations d\'enfants victimes de violences (agressions sexuelles, viols, violences physiques, contrôle coercitif, violence institutionnelle) dont la protection n\'a pas été assurée par les institutions judiciaires françaises, ou qui ont été punis pour les avoir dénoncées en étant placés à l\'ASE.',
            'Contact : recensementenfantsnonproteges@gmail.com',
          ]
        },
        {
          title: '2. Accès au site et dépôt de témoignages',
          content: [
            'L\'accès au site est libre et gratuit. Le dépôt d\'une fiche de recensement est ouvert à toute personne se trouvant dans la situation décrite, ou à un tiers agissant pour son compte avec son consentement explicite.',
            'Toute fiche déposée est soumise à validation par l\'équipe du collectif avant publication. L\'équipe se réserve le droit de refuser, modifier ou retirer toute fiche ne respectant pas les présentes conditions.',
          ]
        },
        {
          title: '3. Règles impératives d\'anonymisation',
          content: [
            '3.1 Obligation d\'anonymisation',
            'Le dépôt d\'une fiche implique l\'obligation stricte d\'anonymiser tous les noms de personnes physiques identifiables : parent agresseur, magistrats, experts, avocats, travailleurs sociaux, ou toute autre personne mentionnée dans le témoignage.',
            'Seules les initiales sont autorisées pour désigner toute personne identifiable. Tout prénom, nom, ou élément permettant l\'identification directe d\'une personne tierce doit être remplacé par ses initiales ou supprimé.',
            '3.2 Responsabilité du déposant',
            'Le déposant est seul responsable du contenu de son témoignage. En déposant une fiche, il garantit avoir respecté l\'obligation d\'anonymisation.',
            'L\'éditrice du site ne saurait être tenue responsable d\'un manquement à cette obligation. Toute fiche contenant des éléments identifiants non anonymisés sera retirée sans délai.',
          ]
        },
        {
          title: '4. Protection des données personnelles (RGPD)',
          content: [
            '4.1 Données collectées',
            'Données privées (jamais publiées) : prénom, nom, téléphone, email et numéro de CNI du parent protecteur. Ces données sont accessibles uniquement à l\'équipe du collectif et sont chiffrées en base de données.',
            'Données publiques : département, tribunal, type de violences, situation de garde, état de la procédure, témoignage (si renseigné), et prénom/nom d\'affichage si le déposant a choisi de les rendre publics.',
            'Les noms et prénoms des enfants ne sont jamais rendus publics sur le site.',
            '4.2 Finalité du traitement',
            'Les données servent à documenter les défaillances systémiques du système judiciaire français et à alimenter des statistiques à destination des journalistes et parlementaires.',
            '4.3 Durée de conservation',
            'Les données sont conservées pour une durée maximale de 5 ans, sauf demande de suppression anticipée.',
            '4.4 Droits des personnes',
            'Conformément au RGPD, vous disposez de droits d\'accès, de rectification, d\'effacement et d\'opposition. Contact : recensementenfantsnonproteges@gmail.com — réponse sous 30 jours.',
          ]
        },
        {
          title: '5. Protection des mineurs',
          content: [
            'Les noms et prénoms des enfants recensés ne sont jamais affichés publiquement. Seule l\'équipe du collectif y a accès.',
            'Toute information permettant d\'identifier un enfant dans un témoignage public doit être anonymisée avant publication.',
          ]
        },
        {
          title: '6. Modération et retrait de contenu',
          content: [
            'L\'équipe se réserve le droit de refuser ou retirer toute fiche en cas de : non-respect de l\'anonymisation, contenu diffamatoire, contenu hors objet, ou risque juridique pour l\'éditrice.',
            'Le déposant peut demander la modification ou suppression de sa fiche à tout moment : recensementenfantsnonproteges@gmail.com',
          ]
        },
        {
          title: '7. Limitation de responsabilité',
          content: [
            'L\'éditrice et le collectif ne sauraient être tenus responsables du contenu des témoignages déposés, qui engagent la responsabilité de leurs seuls auteurs.',
          ]
        },
        {
          title: '8. Propriété intellectuelle',
          content: [
            'Le contenu éditorial est la propriété de l\'éditrice et du collectif. Les témoignages restent la propriété de leurs auteurs, qui accordent au collectif une licence d\'utilisation aux fins du recensement.',
          ]
        },
        {
          title: '9. Droit applicable',
          content: [
            'Les présentes CGU sont régies par le droit français. Les tribunaux français seront seuls compétents en cas de litige.',
          ]
        },
        {
          title: '10. Modification des CGU',
          content: [
            'L\'éditrice se réserve le droit de modifier les présentes CGU à tout moment. Toute modification substantielle sera signalée sur le site.',
          ]
        },
      ].map((section, i) => (
        <div key={i} style={{marginBottom:'28px'}}>
          <h2 style={{fontSize:'16px',fontWeight:'700',marginBottom:'10px',color:'#1a1a1a'}}>{section.title}</h2>
          {section.content.map((text, j) => (
            <p key={j} style={{fontSize:'13px',color:'#444',lineHeight:'1.7',marginBottom:'8px',textAlign:'justify'}}>{text}</p>
          ))}
        </div>
      ))}
    </div>
  );
}
